$(document).ready(function () {
    let data = new FormData()
    $("#list-billboards-home").sortable({
        update: function (event, ui) {
            updateBillboard(event, ui); // Llamada a la función update al mover un elemento
        }
    })

    window.updateBillboard = function (event, ui) {
        let order = [];
        $("#list-billboards-home li").each(function (index) {
            order.push({
                id: $(this).data('id'),
                order: index + 1
            });
        });

        let data = new FormData();
        data.append('items', JSON.stringify(order));
        updatePosition(data, "Registro actualizado");
    }

    function updatePosition(data, msg) {
        $(".loader_").addClass("loading")
        $.ajax({
            method: "POST",
            url: "/admin/update-position-billboard",
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: data,
            success: function (response) {
                console.log(response)
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    alertSuccess(msg)
                    document.getElementById('div_partials_billboard').innerHTML = response;
                    $("#list-billboards-home").sortable({
                        update: function (event, ui) {
                            updateBillboard(event, ui); // Llamada a la función update al mover un elemento
                        }
                    });
                }, 5000)
            }
        })
    }
})

